import { createContext, useState } from 'react';

export const ProductContext = createContext();
export const ProductProvider = ({ children }) => {
    const [isCreatedProduct, setIsCreatedProduct] = useState(null);
    const [isEditedProduct, setIsEditedProduct] = useState(null);
    const [isDeletedProduct, setIsDeletedProduct] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedStoredId, setSelectedStoredId] = useState(null);
    const [productIds, setProductIds] = useState([]);
    const [researchProducts, setResearchProducts] = useState([]);
    
    const addProduct = ( value ) => { setIsCreatedProduct(value) };
    const editProduct = ( value ) => { setIsEditedProduct(value) };
    const clearProduct = () => {
        setIsCreatedProduct(null);
        setIsDeletedProduct(null)
        setIsEditedProduct(null)
        setSelectedProduct(null)
    }
    const setProduct = ( product ) => { 
        setSelectedProduct( product )
    }
    return (
        <ProductContext.Provider value={{ 
            isCreatedProduct, 
            addProduct, 

            selectedProduct,
            setProduct,
            
            isDeletedProduct,
            setIsDeletedProduct,

            isEditedProduct,
            editProduct,

            selectedStoredId, 
            setSelectedStoredId,
            clearProduct,

            productIds,
            setProductIds,

            researchProducts,
            setResearchProducts,
            
         }}>
            {children}
        </ProductContext.Provider>
    );
};
